/* eslint-disable indent */
/* eslint-disable react/prop-types */
import React from "react";

import Button from "../../../component/button/Button";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import SelectInput from "../../../component/input/SelectInput";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import TextArea from "../../../component/input/TextArea";
import TextInput from "../../../component/input/TextInput";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";

const QueryInput = ({
  allLocations,
  queryInput,
  currentUser,
  getImagesUrl,
  handleSubmit,
  queryLoading,
  queryScreenshots,
  handleInitialState,
  queryScreenshotsLoading
}) => {
  return (
    <form className="pl-3 pr-3" onSubmit={handleSubmit}>
      <div className="row mb-2">
        <div className="col-md-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            name="locationId"
            textWhite={false}
            isLabeled={false}
            value={queryInput.locationId}
            label="Select Location"
            onChange={handleInitialState}
          >
            <option value=""> Select Location</option>
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput>
        </div>
        <div className="col-md-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            name="queryCategory"
            textWhite={false}
            isLabeled={false}
            label="Select Category type"
            value={queryInput.queryCategory}
            onChange={handleInitialState}
          >
            <option value="">Select Category Type</option>
            <option value="SOFTWARE">SOFTWARE</option>
            <option value="APP">APP</option>
          </SelectInput>
        </div>
        <div className="col-md-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            name="platformType"
            textWhite={false}
            isLabeled={false}
            label="Select Platform type"
            value={queryInput.platformType}
            onChange={handleInitialState}
          >
            <option value="">Select Platform Type</option>
            <option value="WEB">WEB</option>
            <option value="IOS">IOS</option>
            <option value="ANDROID">ANDROID</option>
          </SelectInput>
        </div>
        <div className="col-md-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            name="queryTypeStatus"
            textWhite={false}
            isLabeled={false}
            label="Select Query type"
            value={queryInput.queryTypeStatus}
            onChange={handleInitialState}
          >
            <option value=""> Select Query Type</option>
            <option value="NEW">NEW</option>
            <option value="REPEATED">REPEATED</option>
          </SelectInput>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 col-xl-8 col-lg-8">
          <div className="row">
            <div className="col-md-5 col-xl-5 col-lg-5">
              <TextInput
                type="text"
                label="Title"
                required={true}
                textWhite={false}
                name="queryTitle"
                placeholder="Enter Title"
                htmlFor="queryTitle"
                value={queryInput.queryTitle}
                onChange={handleInitialState}
              />
            </div>
            <div className="col-md-7 col-xl-7 col-lg-7">
              <TextInput
                type="text"
                required={true}
                label="Subject"
                textWhite={false}
                name="querySubject"
                placeholder="Subject"
                htmlFor="querySubject"
                value={queryInput.querySubject}
                onChange={handleInitialState}
              />
            </div>
          </div>
          <TextArea
            row={8}
            type="text"
            required={true}
            name="queryBody"
            textWhite={false}
            htmlFor="queryBody"
            label="Write a complain"
            value={queryInput.queryBody}
            onChange={handleInitialState}
            placeholder="Enter your query"
          />
        </div>
        <div className="col-md-4 col-xl-4 col-lg-4">
          <div className="mb-5">
            <HeaderTag
              type="h4"
              title="Add photos of your Query"
              isClassName={false}
            />
            <TextInput
              multiple
              type="file"
              file={true}
              required={true}
              textWhite={false}
              htmlFor="queryImages"
              label="Add photos here"
              onChange={getImagesUrl}
            />
          </div>
          <div className="mt-2">
            {queryLoading ? (
              <SpinnerButton />
            ) : queryScreenshotsLoading ? (
              <Button
                disabled
                type="submit"
                title="Submit"
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                className="btn text-white btn-block btn-dark"
              />
            ) : (
              <Button
                type="submit"
                title="Submit"
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                className="btn text-white btn-block btn-dark"
              />
            )}
          </div>
        </div>
      </div>

      <div className="row">
        {queryScreenshots.map((singleScreenShot, index) => (
          <img
            src={singleScreenShot}
            className="img-thumbnail mr-2"
            style={{
              height: "300px",
              width: "200px"
            }}
            key={index}
          />
        ))}
      </div>
    </form>
  );
};

export default QueryInput;
